import type { CustomerStatus } from '../types'

export function subStatusToCustomerStatus(sub?: string | null): CustomerStatus {
  const s = (sub || '').toLowerCase()
  if (s === 'active' || s === 'trialing') return 'ativo'
  if (s === 'past_due' || s === 'unpaid') return 'suspenso'
  if (s === 'incomplete' || s === '') return 'pendente'
  return 'inativo'
}

